/*
  FUNCTIONAL PROTOTYPE - TODO:
  1. Refactor
  2. Add tests
  3. style
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import getProductAttribute from '../../shared/helpers/getProductAttribute';
import CustomReactMarkdown from '../../shared/components/MarkdownRenderers/CustomReactMarkdown';
import ProductInfoBanner from '../../shared/components/ProductInfoBanner/ProductInfoBanner';
import OfferCard from '../../shared/components/OfferCard/OfferCard';


class MediaFeature extends Component {
  static getDomId() {
    return 'product_media_feature';
  }

  static getComponentData() {
    const { product } = window.seMarketplace;

    const mediaFeature = getProductAttribute(product, 'mediaFeature');
    const mediaFeatureText = getProductAttribute(product, 'mediaFeatureText');
    const mediaFeatureDisclaimer = getProductAttribute(product, 'mediaFeatureDisclaimer');
    const showInfoBannerInMediaFeature = getProductAttribute(product, 'showInfoBannerInMediaFeature');
    const detailsInfoBanner = getProductAttribute(product, 'detailsInfoBanner');
    const detailsInfoBannerTheme = getProductAttribute(product, 'detailsInfoBannerTheme');

    if (!mediaFeature) {
      return null;
    }

    return {
      mediaFeature,
      mediaFeatureText,
      mediaFeatureDisclaimer,
      showInfoBannerInMediaFeature,
      detailsInfoBanner,
      detailsInfoBannerTheme,
    };
  }

  constructor(props) {
    super(props);
    this.isImage = props.mediaFeature && /(.jpg|.png|.gif)/.test(props.mediaFeature);
  }

  renderMediaAsset() {
    const { mediaFeature } = this.props;
    const mediaClass = classNames({
      'product-media-feature__image-wrapper': this.isImage,
      'product-media-feature__player-wrapper': !this.isImage,
    });

    return (
      <div className="product-media-feature__media">
        <div className={mediaClass}>
          { this.isImage ? (
            <img src={mediaFeature} alt="Product Media Feature" />
          ) :
            (
              <div className="product-media-feature__player">
                <iframe
                  width="100%"
                  height="100%"
                  src={`https://www.youtube-nocookie.com/embed/${mediaFeature}`}
                  frameborder="0"
                  allowfullscreen
                  referrerpolicy="strict-origin-when-cross-origin"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  title='Product Media Feature'
                />
              </div>
            )
          }
        </div>
      </div>
    );
  }

  renderMediaText() {
    const {
      mediaFeatureText,
      mediaFeatureDisclaimer,
      showInfoBannerInMediaFeature,
      detailsInfoBanner,
      detailsInfoBannerTheme,
    } = this.props;

    if (!mediaFeatureText) {
      return null;
    }

    return (
      <div className="product-media-feature__text-wrapper">
        <h2 className="product-media-feature__title">Installation</h2>
        {showInfoBannerInMediaFeature && detailsInfoBanner && (
          <ProductInfoBanner
            theme={detailsInfoBannerTheme}
            message={detailsInfoBanner}
          />
        )}
        <div className="product-media-feature__text">
          <CustomReactMarkdown source={mediaFeatureText} />
        </div>
        {mediaFeatureDisclaimer && <div className="product-media-feature__disclaimer">
          <OfferCard {...mediaFeatureDisclaimer} />
        </div>}
      </div>
    );
  }

  render() {
    const { mediaFeature } = this.props;

    if (!mediaFeature) {
      return null;
    }

    return (
      <div className="se-tier">
        <div className="se-container">
          <div className="se-row">
            <div className="product-media-feature__left-col">
              {this.renderMediaAsset()}
            </div>
            <div className="product-media-feature__right-col">
              {this.renderMediaText()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MediaFeature.propTypes = {
  mediaFeature: PropTypes.string,
  mediaFeatureText: PropTypes.string,
  mediaFeatureDisclaimer: PropTypes.object,
  showInfoBannerInMediaFeature: PropTypes.bool,
  detailsInfoBanner: PropTypes.string,
  detailsInfoBannerTheme: PropTypes.string,
};

MediaFeature.defaultProps = {
  mediaFeature: undefined,
  mediaFeatureText: undefined,
  mediaFeatureDisclaimer: undefined,
  showInfoBannerInMediaFeature: undefined,
  detailsInfoBanner: undefined,
  detailsInfoBannerTheme: undefined,
};

export default MediaFeature;
